import {
  createFamilyMember as createFamilyMemberApi, getFamilyMemberById as getFamilyMemberByIdApi, updateFamilyMember as updateFamilyMemberApi
  , activateFamilyMember as activateFamilyMemberApi
  , bulkMoveFamilyMembers as bulkMoveFamilyMembersApi
} from "./SpatApi";
import { showErrorToast, showSuccessToast } from "../utils/Toasts";

// Create a new family member
export async function handleCreateFamilyMember(data) {
  try {
    const response = await createFamilyMemberApi(data);
    if (response?.status === 201 || response?.status === 200) {
      showSuccessToast(response?.data?.message || "Family member created successfully.");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while creating family member");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while creating family member.");
    return false;
  }
}

// Fetch family member by ID
export async function fetchFamilyMemberById(familyId) {
  try {
    const response = await getFamilyMemberByIdApi(familyId);
    if (response?.status === 200) {
      return response.data; // Return the fetched family member data
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while fetching family member");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching family member details");
    return false;
  }
}


// Update family member details
export async function updateFamilyMember(updatedFamilyMemberData) {
  try {
    const response = await updateFamilyMemberApi(updatedFamilyMemberData);
    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("Family member updated successfully");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Error updating family member");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error updating family member");
    return false; // Return true on success
  }
}

// Activate family member details
export async function activateFamilyMember(activtedFamilyMemberData) {
  try {
    const response = await activateFamilyMemberApi(activtedFamilyMemberData);
    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("Family member activated successfully");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Error activating family member");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error activating family member");
    return false; // Return true on success
  }
}

// Activate family member details
export async function bulkMoveFamilyMembers(data) {
  try {
    const response = await bulkMoveFamilyMembersApi(data);
    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("Family members moved successfully");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Error moving family members");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error moving family members");
    return false; // Return true on success
  }
}